// extracted by mini-css-extract-plugin
export default {"title":"Title_title__E23Cr","maxContents":"Title_maxContents__tKqsU","minContents":"Title_minContents__8Pj39"};